import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-notification-destination-slack',
  templateUrl: './help-add-notification-destination-slack.component.html',
  styleUrls: ['./help-add-notification-destination-slack.component.scss']
})
export class HelpAddNotificationDestinationSlackComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
